// extracted by mini-css-extract-plugin
export default {"table":"Table_table__rn901","thead":"Table_thead__VFsFq","tbody":"Table_tbody__3Iss8","navigation":"Table_navigation__2ZABL"};